export default function TableHead({ columns }) {
  return (
    <thead className='bg-gray-50'>
      <tr>
        {columns.map((title) => (
          <th key={title} scope='col' className='px-2 md:px-6 py-3 text-left font-bold text-gray-500 capitalize'>
            {title}
          </th>
        ))}
        <th scope='col' className='relative px-2 md:px-6 py-3'>
          <span className='sr-only'>Edit</span>
        </th>
      </tr>
    </thead>
  )
}
